import firestore, { firebase } from '@/firebase'
import { logEvent } from '../../firebase/analytics'
import textHelper from '@/helpers/textHelper'

function getCoursesByUserIds(userIds) {
  return firestore
    .collection('Courses')
    .where('userId', 'in', userIds)
    .get()
    .then(snapshot => {
      return snapshot.docs.map(doc => ({
        ...doc.data(),
        id: doc.id
      }))
    })
    .catch(err => {
      this.$store.dispatch(
        'showErrorSnackbar',
        err.message || 'Something went wrong'
      )
    })
}

export default {
  state: {
    courses: [],
    coordinatorCourses: []
  },
  getters: {
    courses: state => state.courses,
    coordinatorCourses: state => state.coordinatorCourses
  },
  mutations: {
    setCourses(state, courses) {
      state.courses = courses
    },
    setCoordinatorCourses(state, courses) {
      state.coordinatorCourses = courses
    },
    addCourse(state, course) {
      state.courses.push(course)
      return course
    },
    updateCourse(state, course) {
      const idx = state.courses.findIndex(c => c.id === course.id)
      state.courses[idx] = course
      state.courses = [...state.courses]
    },
    deleteCourses(state, courses) {
      for (const { id } of courses) {
        const idx = state.courses.findIndex(c => c.id === id)
        state.courses.splice(idx, 1)
      }
    }
  },
  actions: {
    addCourse({ commit, rootState }, course) {
      course.createdAt = firebase.firestore.FieldValue.serverTimestamp()
      course.updatedAt = firebase.firestore.FieldValue.serverTimestamp()
      return firestore
        .collection('Courses')
        .add(course)
        .then(doc => doc.get())
        .then(course => {
          return commit(
            'addCourse',
            textHelper.setTextsCoursesElement(
              { id: course.id, ...course.data() },
              rootState.langValue
            )
          )
        })
        .then(() => {
          logEvent('TRAINING_LOG_SUBMISSION')
        })
    },
    updateCourse({ commit, rootState }, course) {
      course.updatedAt = firebase.firestore.FieldValue.serverTimestamp()
      return firestore
        .collection('Courses')
        .doc(course.id)
        .update(course)
        .then(() => {
          return commit(
            'updateCourse',
            textHelper.setTextsCoursesElement(course, rootState.langValue)
          )
        })
    },
    setCourses({ commit, rootState }, courses) {
      commit(
        'setCourses',
        textHelper.setTextsCoursesCollection(courses, rootState.langValue)
      )
    },
    setCoordinatorCourses({ commit, rootState }, courses) {
      commit(
        'setCoordinatorCourses',
        textHelper.setTextsCoursesCollection(courses, rootState.langValue)
      )
    },

    getCourses({ commit, rootState }) {
      const userId = rootState.user.user.id
      return getCoursesByUserIds([userId]).then(courses => {
        commit(
          'setCourses',
          textHelper.setTextsCoursesCollection(courses, rootState.langValue)
        )
      })
    },
    getCoordinatorCourses({ commit, rootState }, userIds) {
      return getCoursesByUserIds(userIds).then(courses => {
        commit(
          'setCoordinatorCourses',
          textHelper.setTextsCoursesCollection(courses, rootState.langValue)
        )
      })
    },
    deleteCourses({ commit }, courses) {
      const batch = firestore.batch()
      for (const { id } of courses) {
        const docRef = firestore.collection('Courses').doc(id)
        batch.delete(docRef)
      }
      return batch.commit().then(() => {
        commit('deleteCourses', courses)
      })
    }
  }
}
